import store from '@/store/store';

export const scrollBarStyle = (darkMode) => ({
    '::-webkit-scrollbar': {
        width: '9px',
        scrollBehavior: 'smooth',
    },
    '::-webkit-scrollbar-track': {
        background: darkMode ? '#2c2c2c' : '#fafafa',
    },
    '::-webkit-scrollbar-thumb': {
        background: darkMode ? '#6b6b6b' : '#c7c7c7',
        borderRadius: '8px',
    },
    '::-webkit-scrollbar-thumb:hover': {
        background: darkMode ? '#515151' : '#a6a6a6',
    },
});

function getColorScheme() {
    return store.getState().settings?.colorScheme;
}

export const floatingSelectStyles = (darkMode) => {
    const colorScheme = getColorScheme();
    return {
        'label.chakra-form__label': {
            bg: darkMode ? 'dark.tcap' : 'white',
            color: darkMode
                ? 'rgba(255, 255, 255, 0.7)'
                : 'rgba(0, 0, 0, 0.54)',
            fontWeight: '400',
            letterSpacing: '0.00938em',
            '&[data-focus]': {
                color: `${colorScheme}.500`,
            },
        },
        'div.chakra-react-select__control': {
            bg: darkMode ? 'dark.bgDark' : '#F5F5F5',
        },
    };
};

export const defaultChakraSelectStyle = {
    dropdownIndicator: (provided, { selectProps }) => {
        return {
            ...provided,
            bg: 'transparent',
            px: 2,
            cursor: 'pointer',
            '> svg': {
                transform: `rotate(${selectProps.menuIsOpen ? -180 : 0}deg)`,
                transitionDuration: '.4s',
            },
        };
    },
    indicatorSeparator: (provided) => ({
        ...provided,
        display: 'none',
    }),
};

/**
 * @type {import('chakra-react-select').ChakraStylesConfig} chakraSelectDarkMode
 * @param {string} darkMode
 */
export const chakraSelectDarkMode = (darkMode) => ({
    menuList: (provided, { selectProps }) => ({
        ...provided,
        ...scrollBarStyle(darkMode),
        background: `${
            darkMode && selectProps.onFocus ? 'dark.tcap-weak' : 'white'
        }`,
        borderColor: `${darkMode ? 'dark.tcap-borderGray' : 'inherit'}`,
        color: `${darkMode ? 'white' : 'black'}`,
    }),
    control: (provided) => ({
        ...provided,
        color: `${darkMode ? 'dark.textDark' : 'inherit'}`,
        borderColor: `${darkMode ? 'dark.tcap-borderGray' : 'inherit'}`,
    }),
    option: (provided, { isFocused }) => ({
        ...provided,
        backgroundColor:
            darkMode && isFocused
                ? 'rgba(255, 255, 255, 0.16)!important'
                : null,
    }),
    indicatorsContainer: (provided) => ({
        ...provided,
        background: `${darkMode ? 'dark.bgDark' : 'white'}`,
    }),
    valueContainer: (provided) => ({
        ...provided,
        background: `${darkMode ? 'dark.bgDark' : 'white'}`,
    }),
    inputContainer: (provided) => ({
        ...provided,
        background: `${darkMode ? 'dark.bgDark' : 'white'}`,
        color: `${darkMode ? 'dark.textDark' : 'white'}`,
    }),
});
export const blockSizeEnum = [
    {
        label: '1',
        value: 1,
    },
    {
        label: '10',
        value: 10,
    },
    {
        label: '100',
        value: 100,
    },
];

export const quantityEnum = [
    {
        label: '1',
        value: 1,
    },
    {
        label: '2',
        value: 2,
    },
    {
        label: '3',
        value: 3,
    },
    {
        label: '4',
        value: 4,
    },
    {
        label: '5',
        value: 5,
    },
    {
        label: '6',
        value: 6,
    },
    {
        label: '7',
        value: 7,
    },
    {
        label: '8',
        value: 8,
    },
    {
        label: '9',
        value: 9,
    },
    {
        label: '10',
        value: 10,
    },
];

export const initialFormState = {
    contactName: '',
    contactPhone: '',
    contactEmail: '',
    comments: '',
    country: '',
    region: '',
    state: '',
    suburb: '',
    street: '',
    postcode: '',
};
export const initialSelectState = {
    blockSize: '',
    quantity: '',
};
